import React from "react";
import SideBySideSectionCard from "../SideBySideSectionCard/SideBySideSectionCard";
import CustomTable from "../CustomTable/CustomTable";

function TransferenciaInternacional() {
  const subtext1 = (
    <p>
      No contexto da prestação de serviços e das atividades operacionais da
      CAIXA Consórcio, poderá ser necessária a realização de transferência
      internacional de dados pessoais para organizações localizadas fora do
      Brasil para as seguintes finalidades:
    </p>
  );

  const subtext4 = (
    <>
      <p>
        Essas transferências são realizadas de forma segura e em conformidade
        com a LGPD, seguindo as regras definidas pela Autoridade Nacional de
        Proteção de Dados (ANPD), em especial as previstas na Resolução CD/ANPD
        nº 19, de 23 de agosto de 2024, que regulamenta os mecanismos válidos de
        transferência internacional de dados.
      </p>
      <p>
        {" "}
        Para que uma transferência internacional seja realizada em conformidade
        com a regulação aplicável, utilizamos cláusulas-padrão contratuais
        aprovadas pela ANPD, formalmente incorporadas aos contratos firmados com
        prestadores de serviço ou parceiros localizados no exterior.
      </p>
      <p>
        {" "}
        As transferências de dados pessoais serão realizadas ao longo do período
        de tratamento, observando os prazos definidos para cada caso e sempre em
        conformidade com a finalidade específica de cada transferência.
      </p>
      <p>
        Por fim, destacamos que você, como titular de dados pessoais, pode a
        qualquer tempo, solicitar informações adicionais sobre as transferências
        internacionais realizadas.
      </p>
    </>
  );

  const finalidadeTransferenciaTable = (
    <CustomTable
      headers={["Finalidade da transferência", "País de destino"]}
      rows={[
        [
          "Armazenamento de dados pessoais em servidor de cloud",
          "Estados Unidos, México e União Europeia.",
        ],
        [
          "Processamento de operações voltadas para atividades de KYC",
          "Estados Unidos e União Europeia.",
        ],
        [
          "Realização de suporte técnico ou operação de sistemas",
          "Estados Unidos.",
        ],
        [
          "Envio de informações para empresas do grupo econômico CAIXA para gestão centralizada de processos.",
          "França.",
        ],
      ]}
    />
  );

  return (
    <div>
      <SideBySideSectionCard
        id="TransferenciaInternacional"
        title="Transferência internacional de dados pessoais"
        subtext1={subtext1}
        subtext2={finalidadeTransferenciaTable}
        subtext4={subtext4}
      />
    </div>
  );
}

export default TransferenciaInternacional;
